import React, { useState } from "react";
import { MdCheckCircle } from "react-icons/md";
import "./SchoolDropdown.css";

const SchoolDropdown = ({ schools, selectedSchool, onSelect }) => {
    const [showDropdown, setShowDropdown] = useState(false);

    const handleSelect = (school) => {
        setShowDropdown(false);
        onSelect(school);
    };



    return (
        <div className="school-dropdown-container">
            <div className="school-dropdown-wrapper" onClick={() => setShowDropdown(!showDropdown)}>
                {showDropdown ? (
                    <div className="school-name-label spaced">
                        <span>Nama</span>
                        <span>Kod</span>
                    </div>
                ) : (
                    <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <img
                                src={`${process.env.PUBLIC_URL}/assets/alquran.png`}
                                alt="School Logo"
                                className="school-logo"
                                onError={(e) => {
                                    e.target.src = `${process.env.PUBLIC_URL}/assets/alquran.png`;
                                }}
                            />
                            <div className="school-name-label">{selectedSchool?.name}</div>
                        </div>
                        {selectedSchool?.isAdmin && (
                            <div className="school-admin-label">
                                <MdCheckCircle size={14} /> Admin
                            </div>
                        )}
                    </>
                )}

            </div>

            {showDropdown && (
                <>
                    <div className="school-dropdown-overlay" onClick={() => setShowDropdown(false)}></div>

                    <div className="school-dropdown-options">
                        {schools.map((school) => (
                            <div
                                key={school.schoolId}
                                onClick={() => handleSelect(school)}
                                className={`school-option ${selectedSchool?.schoolId === school.schoolId ? "selected" : ""}`}
                            >
                                <div className="school-option-content">
                                    <span className="school-name-left">{school.name}</span>
                                    <span className="school-code-right">{school.secretCode}</span>
                                </div>
                                <div className="school-info-box">
                                    Kod ini digunakan semasa pendaftaran guru & pelajar untuk masuk ke sekolah yang sama.

                                </div>


                                {/* {school.isAdmin && (
                                    <span className="admin-label">
                                        <MdCheckCircle size={14} /> Admin
                                    </span>
                                )} */}
                            </div>
                        ))}
                    </div>
                </>
            )}


        </div>
    );
};

export default SchoolDropdown;
